import { render, staticRenderFns } from "./investigationPlan.vue?vue&type=template&id=44dad5aa"
import script from "./investigationPlan.vue?vue&type=script&lang=js"
export * from "./investigationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44dad5aa')) {
      api.createRecord('44dad5aa', component.options)
    } else {
      api.reload('44dad5aa', component.options)
    }
    module.hot.accept("./investigationPlan.vue?vue&type=template&id=44dad5aa", function () {
      api.rerender('44dad5aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/investigationPlan.vue"
export default component.exports